export * from './flow-schema.js';
export * from './flow-compiler.js';
export * from './skin-scan-types.js';
export * from './skin-scan-mock.js';
export * from './perfectcorp-skin-map.js';
export * from './storefront-lead-magnets.js';
export * from './storefront-home-landing.js';
export * from './storefront-site-settings.js';
export * from './storefront-ux.js';
export * from './showroom-tour.js';
export * from './showroom-location.js';
export * from './catalog-product-tags.js';
export * from './catalog-import-inference.js';
export * from './catalog-import-disambiguate.js';
export * from './import-marque-parse.js';
export {
  defaultDuplicateRowDisposition,
  duplicateRowImportIndex,
  orderedDuplicateImportRows,
  resolveDuplicateRowDispositions,
  rowDispositionToResolution,
  type DuplicateConflictLike,
  type DuplicateResolutionLike,
  type DuplicateRowDisposition,
} from './catalog-import-duplicate-resolution.js';
export * from './lead-core.js';
export * from './phone.js';
export * from './phone-profile.js';
export * from './email.js';
export * from './staff-email.js';
export * from './order-reference.js';
export * from './address-locations.js';
export * from './customer-reference.js';
export * from './sales-channel.js';
export * from './notification-channel.js';
export * from './observability.js';
export * from './error-flows.js';
export * from './repro-breadcrumbs.js';
export * from './organization-entity.js';
export * from './hamssah-contact.js';
export * from './storefront-excluded-product-types.js';
export * from './supportScreenshot.js';
export * from './supportTicketError.js';

/** API response envelope (gateway-style). */
export type ApiEnvelope<T> = { data: T; meta?: Record<string, unknown> };

export const unwrapData = <T>(body: unknown): T => {
  if (body && typeof body === 'object' && 'data' in body) {
    const d = (body as { data: unknown }).data;
    if (d && typeof d === 'object' && 'data' in (d as object)) {
      return (d as { data: T }).data;
    }
    return d as T;
  }
  return body as T;
};
